import { render } from "./AccountsList.vue?vue&type=template&id=7bef2f5e"
import script from "./AccountsList.vue?vue&type=script&lang=js"
export * from "./AccountsList.vue?vue&type=script&lang=js"

import "./AccountsList.vue?vue&type=style&index=0&id=7bef2f5e&lang=css"

import exportComponent from "/codebuild/output/src822836300/src/awsmng/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__